
<template>
    <el-row>
    <el-form :model="sencondMarketForm"

                             ref="IntranetClueItemRef"
                             :rules="rules"
                             @onSelectInfo="onSelectInfo"
                             addAction="/secondHandCarMarket/saveOrUpdateLcwpSecondHandCarMarkt.action"
                             editAction="/secondHandCarMarket/saveOrUpdateLcwpSecondHandCarMarkt.action"
                             selectAction="/secondHandCarMarket/selectSecondMarketInfo.action"
                             label-width="150px"
                             style="width:80%"
                             v-form>
      <el-row>
        <el-form-item label="品牌车型:" prop="category">
          <p>{{sencondMarketForm.brand}} {{sencondMarketForm.series}} {{sencondMarketForm.category}} {{sencondMarketForm.officePrice/(10000*100)}}万</p>
          <brand-and-series-categories-select @onChanged="carCategoryChange"
                                              brandPlaceholder="品牌（单选）" categoriesPlaceholder="车型(单选)"
                                              ref="brand-and-series-select"
                                              seriesPlaceholder="车系（单选）" :categoriesMultiple="false"></brand-and-series-categories-select>

        </el-form-item>
      </el-row>

      <el-row>
        <el-col :span="12">

          <el-form-item label="表显里程:" prop="mileage">
            <el-input v-model="sencondMarketForm.mileage"  type="number" placeholder="请输入（单位：公里）"></el-input>
          </el-form-item>
          <el-form-item label="上牌日期:" prop="licenseTime">
            <el-date-picker
                v-model="sencondMarketForm.licenseTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上牌地址:" prop="licenseAddress">
            <search-city-input ref="licenseAddress" v-model="sencondMarketForm.licenseAddress" placeholder="请选择（支持搜索联想输入）" :defaultValue="sencondMarketForm.licenseAddress" @onChenged="onChangeLicenseAddress"></search-city-input>
          </el-form-item>
          
          <el-form-item label="批发价:" prop="businessPrice">
            <el-input v-model="sencondMarketForm.businessPrice" type="number" placeholder="批发价（元）"></el-input>
          </el-form-item>

        </el-col>

      </el-row>



      <el-form-item>
        <el-button type="primary">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>

import SearchAreaInput from '@/components/SearchAreaInput'
import SearchCityInput from '@/components/SearchCityInput'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'
import BrandAndSeriesCategoriesSelect from '@/components/BrandAndSeriesCategoriesSelect'
import draggable from 'vuedraggable'
export default {
  name: 'saveOrUpdateSencondMarket',
  extends: BasicPager,
  components: { BrandAndSeriesCategoriesSelect, SearchAreaInput, SearchCityInput, draggable },
  data: function () {
    let checkInt = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{0})?$/)
      if (!match) {
        return callback(new Error('只能为整数！'))
      }

      callback()
    }
    return {
      baseImageUrl: Config.imageUrl,
      rules: {
        category: [
          { required: true, message: '车型名称不能为空', trigger: 'blur' }
        ],

        mileage: [
          { required: true, message: '请输入公里', trigger: 'blur' }
        ],
        licenseTime: [
          { required: true, message: '请输入上牌时间', trigger: 'blur' }
        ],
        licenseAddress: [
          { required: true, message: '请输入车牌所在地', trigger: 'blur' }, { max: 40, message: '车牌所在地不能大于40位！' }
        ],

        businessPrice: [
          { required: true, message: '请输入批发价(元)', trigger: 'blur' }
        ]

      },
      sencondMarketForm: {
        id: null,
        brandId: null,
        seriesId: null,
        categoryId: null,
        brand: null,
        series: null,
        category: null,
        officePrice: null,
        licenseAddress:null,
        licenseTime:null,
        mileage:null,
        type:7,
        businessType:1,
        goodsName:null,
        businessPrice:null,
        year : null

      }
    }
  },
  created () {
    if (this.$route.params.id) {
      this.sencondMarketForm.id = this.$route.params.id
    }
  },
  methods: {

    onChangeLicenseAddress: function (addressInfo) {
      // 查询省市区areaCode

      let city = addressInfo.province + ' ' + addressInfo.city
      this.sencondMarketForm.licenseAddress = city
    },
    onChangeLocationCity: function (addressInfo) {
      // 查询省市区areaCode
      let city = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county
      this.sencondMarketForm.locationCity = city
    },
    onFilterParams: function (params) {


      params.businessPrice = parseInt(params.businessPrice)*100
      params.goodsName = params.brand + " " +params.series + " " + params.category

    },
    onSelectInfo: function (dataInfo) {
      console.log(2222)

      let brandAndSeriesSelect = this.$refs['brand-and-series-select']
      if (brandAndSeriesSelect) {
        brandAndSeriesSelect.setValue(dataInfo.datas.brandId, dataInfo.datas.seriesId, dataInfo.datas.categoryId)
        this.sencondMarketForm.categoryId = dataInfo.datas.categoryId
      }

      if(dataInfo.datas){
          this.sencondMarketForm.businessPrice = dataInfo.datas.businessPrice/100
          console.log(this.sencondMarketForm)
      }
      console.log(2222)

    },
    carCategoryChange: function (brandInfo, seriesInfo, categoriesInfo) {
      // 品牌车系车型
      if (brandInfo) {
        this.sencondMarketForm.brandId = brandInfo.id
        this.sencondMarketForm.brand = brandInfo.name
      } else {
        this.sencondMarketForm.brandId = null
        this.sencondMarketForm.brand = null
      }

      if (seriesInfo) {
        this.sencondMarketForm.seriesId = seriesInfo.id
        this.sencondMarketForm.series = seriesInfo.name
      } else {
        this.sencondMarketForm.seriesId = null
        this.sencondMarketForm.series = null
      }

      if (categoriesInfo) {
        this.sencondMarketForm.categoryId = categoriesInfo.id
        this.sencondMarketForm.category = categoriesInfo.name
        this.sencondMarketForm.officePrice = categoriesInfo.price * 100
        this.sencondMarketForm.year = categoriesInfo.year
      } else {
        this.sencondMarketForm.categoryId = null
        this.sencondMarketForm.category = null
      }
    }
  },
  filters: {}

}
</script>

<style scoped>

  .img-temp-list {
    padding-left: 0;
    display: flex;
    align-items: center;
    flex-warp: warp;
  }

  .img-temp-item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    display: inline-block;
    position: relative;
  }

  .img-temp-item img {
    width: 100%;
    height: 100%;
  }
  .img-temp-item:hover .img-action {
    opacity: 1;
  }

  .img-temp-item .img-action {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    opacity: 0;
  }
  .img-action i {
    font-size: 20px;
    color: #fff;
    margin-left: 15px;
    cursor: pointer;
  }
  .img-action i:first-child {
    margin-left: 0;
  }
</style>
